export default "__VITE_ASSET__CJdNA3NC__"